document.addEventListener('DOMContentLoaded', () => {
  // aos.js
  AOS.init({
    // ここにオプションを記述します
    offset: 120,      // 登場位置のオフセット (px)
    delay: 0,         // 遅延時間 (ms)
    duration: 600,    // アニメーション速度 (ms)
    easing: 'ease-out-quart',   // イージング
    once: false,      // 一回きりにするかどうか
    mirror: false,    // スクロールで戻った時に再度アニメーションするか
    anchorPlacement: 'top-bottom', // アニメーションが発火する位置関係
  });

  // 840px以下ではdata-aos-delayを削除
  const removeDelayOnSmallScreen = () => {
    if (window.innerWidth <= 840) {
      document.querySelectorAll('.js-sp-nodelay [data-aos-delay]').forEach(el => {
        el.removeAttribute('data-aos-delay');
      });
      AOS.refresh(); // AOSをリフレッシュ
    }
  };

  // 初期実行
  removeDelayOnSmallScreen();

  // リサイズ時にも実行
  window.addEventListener('resize', removeDelayOnSmallScreen);

  // swiper
  if (document.querySelector('.swiper-case-study')) {
    new Swiper('.swiper-case-study', {
      slidesPerView: 1,
      loop: true,
      // autoplay: {
      //   delay: 4000,
      // },
      spaceBetween: 40,
      // Add pagination
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      // Add navigation
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }

  // Gnav
  const navItemsWithSubmenu = document.querySelectorAll('.g-header__nav__item--has-submenu');

  navItemsWithSubmenu.forEach(item => {
    const link = item.querySelector('.g-header__nav__link');

    // --- クリック処理 ---
    // is-sticky クラスを制御し、クリックでメニューを「固定」する
    // 2回目以降のクリックではリンク先に遷移する
    link.addEventListener('click', function (e) {
      // 既にスティッキー状態（is-sticky）なら、通常のリンクとして遷移
      if (item.classList.contains('is-sticky')) {
        return;
      }

      // スティッキーでなければ、デフォルトの遷移を止めてメニューを開く
      e.preventDefault();
      e.stopPropagation(); // document のクリックイベントへの伝播を止める

      // 他のアイテムのスティッキー状態を解除
      navItemsWithSubmenu.forEach(other => {
        if (other !== item) {
          if (other._closeTimer) {
            clearTimeout(other._closeTimer);
            other._closeTimer = null;
          }
          other.classList.remove('is-sticky', 'is-open');
          other.setAttribute('aria-expanded', 'false');
        }
      });

      // このアイテムをスティッキー状態にして開く
      if (item._closeTimer) {
        clearTimeout(item._closeTimer);
        item._closeTimer = null;
      }
      item.classList.add('is-sticky', 'is-open');
      item.setAttribute('aria-expanded', 'true');
    });

    // --- ホバー処理 ---
    // is-sticky がない場合に限り、マウスホバーで開閉する
    item.addEventListener('mouseenter', () => {
      if (item._closeTimer) {
        clearTimeout(item._closeTimer);
        item._closeTimer = null;
      }

      // 他のメニューが開いていたら即座に閉じる（is-sticky も含めて解除）
      navItemsWithSubmenu.forEach(other => {
        if (other !== item) {
          if (other._closeTimer) {
            clearTimeout(other._closeTimer);
            other._closeTimer = null;
          }
          other.classList.remove('is-sticky', 'is-open');
          other.setAttribute('aria-expanded', 'false');
        }
      });

      item.classList.add('is-open');
      item.setAttribute('aria-expanded', 'true');
    });

    item.addEventListener('mouseleave', () => {
      // is-sticky クラスがなければ（クリックで固定されていなければ）閉じる
      if (!item.classList.contains('is-sticky')) {
        item._closeTimer = setTimeout(() => {
          item.classList.remove('is-open');
          item.setAttribute('aria-expanded', 'false');
          item._closeTimer = null;
        }, 300);
      }
    });
  });

  // サブメニューがないリンクをホバーしたら開いているサブメニューを閉じる
  const noSubmenuLinks = document.querySelectorAll('.g-header__nav__item.g-header__nav__link--no-submenu');
  noSubmenuLinks.forEach(link => {
    link.addEventListener('mouseenter', () => {
      navItemsWithSubmenu.forEach(item => {
        if (item._closeTimer) {
          clearTimeout(item._closeTimer);
          item._closeTimer = null;
        }
        item.classList.remove('is-sticky', 'is-open');
        item.setAttribute('aria-expanded', 'false');
      });
    });
  });

  // ハンバーガー開閉
  const header = document.querySelector('.g-header');
  const hamburger = document.querySelector('.g-header__hamburger');
  const gnav = document.getElementById('g-header-nav');
  if (hamburger && header && gnav) {
    hamburger.addEventListener('click', function (e) {
      const open = header.classList.toggle('is-open');
      hamburger.setAttribute('aria-expanded', open ? 'true' : 'false');
      gnav.setAttribute('aria-hidden', open ? 'false' : 'true');

      // サブメニューの aria-hidden を更新（アクセシビリティ用）
      const submenus = document.querySelectorAll('.g-header__nav__submenu');
      submenus.forEach(sm => {
        sm.setAttribute('aria-hidden', open ? 'false' : 'true');
      });
    });
  }

  // クリック外で閉じる
  document.addEventListener('click', function (e) {
    // is-sticky 状態のメニューがあれば解除して閉じる
    navItemsWithSubmenu.forEach(i => {
      if (i.classList.contains('is-sticky')) {
        i.classList.remove('is-sticky', 'is-open');
        i.setAttribute('aria-expanded', 'false');
      }
    });

    // ハンバーガーメニュー外クリックで閉じる
    if (!e.target.closest('.g-header')) {
      if (header && header.classList.contains('is-open')) {
        header.classList.remove('is-open');
        if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
        if (gnav) gnav.setAttribute('aria-hidden', 'true');
      }
    }
  });
});